<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="disclaimer-page" fxFill fxLayout="row" fxLayoutAlign="center center">
    <mat-card fxFlex.xs="1 1 auto"
              fxFlex.md="1 1 80vw"
              fxFlex.gt-md="1 1 60vw"
              fxFlex.gt-lg="1 1 30vw"
              class="disclaimer-card mat-elevation-z2">
        <mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="mat-toolbar-tools">Welcome to {{ siteName }}</h2>
        </mat-toolbar>
        <mat-card-content>
            <div class="site-description" [innerHTML]="siteDescription"></div>
            <div fxLayout="column" fxLayoutAlign="space-between stretch">
                <button mat-raised-button color="primary"
                        (click)="showLogin()">Continue</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
